import { ElementBase as o } from "@smartdesign/element-base";
const d = `<style>
	:host {
		contain: content;
		background: rgba(20, 103, 186, 0);
		color: #1467ba;
		border: none;
		outline: none;
		padding: 0 8px;
		height: 32px;
		cursor: pointer;
		user-select: none;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		vertical-align: middle;
	}

	:host(:focus),
	:host(:not([disabled], [aria-disabled="true"]):hover) {
		background: rgba(20, 103, 186, 0.1);
	}

	@media (forced-colors: active) {
		:host(:not([disabled], [aria-disabled="true"]):focus-visible) {
			outline: 1px solid;
		}
		:host {
			margin: 1px;
		}
	}

	:host(:not([disabled], [aria-disabled="true"]):focus-visible) {
		box-shadow: 0 0 0 1px #1467ba inset;
	}

	:host(:not([disabled], [aria-disabled="true"]):active) {
		background: rgba(20, 103, 186, 0.2);
	}

	:host([primary]) {
		background: #1467ba;
		color: #fff;
	}

	:host([primary]:focus),
	:host(:not([disabled], [aria-disabled="true"])[primary]:hover) {
		background: #125da8;
	}

	:host([primary]:focus-visible) {
		box-shadow: 0 0 0 1px white inset;
	}

	:host(:not([disabled], [aria-disabled="true"])[primary]:focus-visible) {
		outline: 1px solid #1467ba;
	}

	:host(:not([disabled], [aria-disabled="true"])[primary]:active) {
		background: #0e4883;
	}

	:host([disabled]),
	:host([aria-disabled="true"]) {
		filter: grayscale(100%);
		opacity: 0.5;
		cursor: default;
	}

	:host([disabled]:focus-visible),
	:host([aria-disabled="true"]:focus-visible) {
		outline: 1px dashed #111;
	}

	:host(:not([icon])) .icon,
	:host([icon=""]) .icon {
		display: none;
	}

	.content {
		display: flex;
		align-items: center;
		min-width: 0px;
	}

	.content ::slotted(*) {
		margin-left: var(--sd-button-content-padding, 8px);
	}

	.content ::slotted(*:last-child) {
		margin-right: var(--sd-button-content-padding, 8px);
	}

	.icon {
		max-height: var(--sd-button-max-icon-size, 32px);
		max-width: var(--sd-button-max-icon-size, 32px);
	}
</style>
<img class="icon" />
<div class="content">
	<slot></slot>
</div>
`, s = class s extends o {
  constructor() {
    super(), this._isSpaceOrEnterKeyDown = !1, this.addEventListener("keydown", (t) => {
      this.isSpaceOrEnter(t) && (this._isSpaceOrEnterKeyDown = !0, t.preventDefault());
    }), this.addEventListener("keyup", (t) => {
      this.isSpaceOrEnter(t) && this._isSpaceOrEnterKeyDown == !0 && (this._isSpaceOrEnterKeyDown = !1, this.click());
    }), this.addEventListener(
      "click",
      (t) => {
        var r, a;
        if (this.disabled || this.hasAttribute("disabled")) {
          t.stopImmediatePropagation();
          return;
        }
        const n = (a = (r = this.getAttribute("type")) == null ? void 0 : r.toLowerCase()) == null ? void 0 : a.trim();
        if (n !== "submit" && n !== "reset")
          return;
        const i = this.closest("form");
        i && n === "submit" && i.requestSubmit(), i && n === "reset" && i.reset();
      },
      { capture: !0 }
    );
  }
  get imageElement() {
    return this._image;
  }
  get icon() {
    return this.getAttribute("icon");
  }
  set icon(t) {
    this.icon !== t && (t ? this.setAttribute("icon", t) : this.removeAttribute("icon"), this.updateIcon());
  }
  get primary() {
    return this.hasAttribute("primary");
  }
  set primary(t) {
    t ? this.setAttribute("primary", "") : this.removeAttribute("primary");
  }
  get disabled() {
    return this.getAttribute("aria-disabled") == "true";
  }
  set disabled(t) {
    this.setAttribute("aria-disabled", t.toString());
  }
  static get observedAttributes() {
    return ["icon"];
  }
  is() {
    return s.ID;
  }
  template() {
    const t = document.createElement("template");
    return t.innerHTML = d, t;
  }
  isSpaceOrEnter(t) {
    switch (t.key) {
      case " ":
      case "Space":
      case "Enter":
        return !0;
      default:
        return !1;
    }
  }
  click() {
    !this.disabled && !this.hasAttribute("disabled") && super.click();
  }
  connectedCallback() {
    super.connectedCallback(), this.hasAttribute("tabIndex") || (this.tabIndex = 0), this._image = this.shadowRoot.querySelector(".icon"), this.updateIcon(), this.hasAttribute("role") || this.setAttribute("role", "button");
  }
  attributeChangedCallback() {
    this.updateIcon();
  }
  updateIcon() {
    if (this._image) {
      const t = this.getAttribute("icon");
      t && (this._image.src = t);
    }
  }
};
s.ID = "sd-button";
let e = s;
customElements.get(e.ID) || customElements.define(e.ID, e);
export {
  e as Button
};
//# sourceMappingURL=button.mjs.map
